import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, FormInstance, FormProps, Input, Modal, Select } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { ICategoryCar, ICategoryCarEdit, editCategoryCar } from "../../../../../api/categoryCar/categoryCarApi"
import { URL_CAR_CATEGORY } from "../../../../../env"
import { useForm } from "antd/lib/form/Form"
import { ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { getCLCarLines, getCLTypeVehicle, getCLVehicleGroup } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
import { editProduct, IProduct } from "../../../../../api/carProduct/carProductApi"
interface ModalProps {
  isOpen: boolean
  infoProduct?: IProduct
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}

const ModalEdit: React.FC<ModalProps> = ({
  isOpen, infoProduct,
  onSubmitFormModal, closeModal
}) => {
  const inputRef = useRef<FormInstance>(null);
  const [form] = useForm();
  const isProgrammaticCarLineSet = useRef(false);
  const isProgrammaticTypeVehicleSet = useRef(false);
  const carLineId = Form.useWatch("carLineId", form);
  const typeVehicleId = Form.useWatch("typeVehicleId", form);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])
  const [cLVehicleGroup, setCLVehicleGroup] = useState<ISelectOption[]>([])


  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLTypeVehicle = async () => {
    if (!carLineId) return
    const result = await getCLTypeVehicle(carLineId)
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const gCLVehicleGroup = async () => {
    if (!typeVehicleId) return
    const result = await getCLVehicleGroup(carLineId, typeVehicleId)
    if (result?.status) {
      setCLVehicleGroup(fommatSelectOption(result.data))
    }
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    if (!infoProduct?.id) return
    const {
      code, title, carLineId, typeVehicleId,
      groupVehicleId
    } = values
    const result = await editProduct(
      infoProduct.id, code, title, carLineId,
      typeVehicleId, groupVehicleId
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (carLineId) {
      gCLTypeVehicle()
    }

    if (isProgrammaticCarLineSet.current) {
      isProgrammaticCarLineSet.current = false;
      return;
    }
    form.setFieldValue("typeVehicleId", undefined);
  }, [carLineId]);

  useEffect(() => {
    if (typeVehicleId) {
      gCLVehicleGroup()
    }

    if (isProgrammaticTypeVehicleSet.current) {
      isProgrammaticTypeVehicleSet.current = false;
      return;
    }
    form.setFieldValue("groupVehicleId", undefined);
  }, [typeVehicleId]);

  useEffect(() => {
    if (isOpen) {
      if (!cLCarLines.length)
        gCLCarLines()

      if (infoProduct) {
        isProgrammaticCarLineSet.current = true;
        isProgrammaticTypeVehicleSet.current = true;

        const {
          code, title, carLineId, typeVehicleId, groupVehicleId,
        } = infoProduct
        form.setFieldsValue({
          code: code,
          title: title,
          carLineId: carLineId,
          typeVehicleId: typeVehicleId,
          groupVehicleId: groupVehicleId
        });
      }

    } else {
      isProgrammaticCarLineSet.current = false;
      isProgrammaticTypeVehicleSet.current = false;
      form.resetFields()
    }
  }, [isOpen]);
  return (

    <Form
      form={form}
      ref={inputRef as any}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
            <span className="text-base text-344054 fw-500 font-medium">
              Chỉnh sửa sản phẩm
            </span>
            <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
          </div>
        }
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer" onClick={closeModal}>
              Huỷ
            </span>
            <button
              className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}
            >
              Lưu
            </button>
          </div>
        }
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-4">
              <Form.Item
                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="carLineId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select
                  allowClear
                  options={cLCarLines}
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="typeVehicleId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn loại xe!' }]}
              >
                <Select
                  disabled={!carLineId}
                  allowClear
                  options={cLTypeVehicle}
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Nhóm sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="groupVehicleId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn nhóm!' }]}
              >
                <Select
                  disabled={!typeVehicleId}
                  allowClear
                  options={cLVehicleGroup}
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã sản phẩm!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã sản phẩm"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Tên sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập tên sản phẩm!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Nhập tên sản phẩm"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Modal>
    </Form>

  )
}
export default ModalEdit
